import api from '../../../app/api';
import getAll from './get-accounts';
import addAccount from './add-account';
import deleteAccount from './delete-account';

export const accountsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAccounts: getAll(build),
        addAccount: addAccount(build),
        deleteAccount: deleteAccount(build),
    }),
});

export const { useGetAccountsQuery, useAddAccountMutation, useLazyGetAccountsQuery, useDeleteAccountMutation } =
    accountsApi;
